"use strict";
'app public';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  props: {
    pluginElement: Element,
    pluginProps: Object
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["utils"]) window._app_exports["components"]["utils"] = {};
window._app_exports["components"]["utils"]["PluginWrapper"]
window._app_exports.components.utils.PluginWrapper = exports.default ? exports.default : exports;
